import PhysicalSampleState from './PhysicalSampleState';

export default class PhysicalSampleWriteDTO {
    public id: number | undefined;
    public macAddress: string | undefined;
    public state: PhysicalSampleState | undefined;
    public ownerDealershipId: number | undefined;
    public sampleId: number | undefined;
    public studioId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'] || undefined;
        this.macAddress = data['macAddress'] || undefined;
        this.state = data['state'] || undefined;
        this.ownerDealershipId = data['ownerDealershipId'] || undefined;
        this.sampleId = data['sampleId'] || undefined;
        this.studioId = data['studioId'] || undefined;
    }
}
